import ImageOne from '../images/one.jpg';
import ImageTwo from '../images/two.jpg';
import ImageThree from '../images/three.jpg';
import ImageFour from '../images/four.jpg';
import ImageFive from '../images/five.jpg';
import ImageSix from '../images/six.jpg';

export const galleryData =[ 
    {
    image: ImageOne,
    delay: 100,
    },
    {
    image: ImageTwo,
    delay: 100,
    },
    {
    image: ImageThree,
    delay: 100,
    },
    {
    image: ImageFour,
    delay: 100,
    },
    {
    image: ImageFive,
    delay: 100,
    },
    {
    image: ImageSix,
    delay: 100,
    },
    {
    image: ImageSix,
    delay: 100,
    }
]